'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _base = require('./base/base.js');

var _base2 = _interopRequireDefault(_base);

var _modules = require('./modules/modules.config');

var _modules2 = _interopRequireDefault(_modules);

require('./ie.polyfill.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appName = 'app';

angular.module(appName, ['views', _base2.default].concat(_modules2.default));

exports.default = appName;


//////////////////
// WEBPACK FOOTER
// ./app/app.js
// module id = 1
// module chunks = 0